<script>
import { permissionTitles } from '@/constants';
import { diffKinds as kinds } from '../constants';

const mapFieldTitle = {
  username: 'Логин',
};

export default {
  props: {
    changes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    permissionsChanges () {
      const result = [];

      this.changes.forEach(change => {
        const [field, value] = change.path;

        if (field !== 'permissions') {
          return;
        }

        if (value) {
          const side = change.lhs ? 'lhs' : 'rhs';

          result.push({ [side]: value });
          return;
        }

        Object.keys(change.lhs || {}).forEach(lhs => result.push({ lhs }));
        Object.keys(change.rhs || {}).forEach(rhs => result.push({ rhs }));
      });

      return result;
    },
    fieldsChanges () {
      return this.changes.filter(change => change.path[0] !== 'permissions');
    },
  },
  render () {
    return (
      <div>
        {this.fieldsChanges.map(change => {
          const [field] = change.path;
          const lhs = change.kind !== kinds.add ? String(change.lhs) : null;
          const rhs = change.kind !== kinds.remove ? String(change.rhs) : null;

          if (!lhs && !rhs) {
            return null;
          }

          return (
            <div
              key={field}
              class="journal-diff"
            >
              <div class="journal-diff__field">
                {mapFieldTitle[field]}
              </div>
              {lhs && (
                <span class="journal-diff__del">
                  {lhs}
                </span>
              )}
              {rhs && (
                <span class="journal-diff__ins">
                  {rhs}
                </span>
              )}
            </div>
          );
        })}
        {this.permissionsChanges.length > 0 && (
          <div
            key="__permissions"
            class="journal-diff"
          >
            <div class="journal-diff__field">
              Права доступа
            </div>
            {this.permissionsChanges.map((change, i) => {
              const { lhs, rhs } = change;

              return (
                <div key={i}>
                  {lhs && (
                    <span class="journal-diff__del">
                      {permissionTitles[lhs]}
                    </span>
                  )}
                  {rhs && (
                    <span class="journal-diff__ins">
                      {permissionTitles[rhs]}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  },
};
</script>
